<template>
  <v-container>
    <v-dialog
      v-model="newUserModal"
      max-width="500px"
    >
      <v-card>
        <v-app-bar
              dark
              color="blue"
            >
              <v-toolbar-title>New User Access</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn
                icon
                style="float:right"
                @click="toggleNewUserModal"
              >
                <v-icon>close</v-icon>
              </v-btn>
            </v-app-bar>
        <v-card-text>
          <v-container grid-list-md>
            <v-form
              ref="form"
              v-model="newUser.valid"
              lazy-validation
            >
            <v-select
              v-model="newUser.accountType"
                     :items="['townsendharris.org','other']"
                     label="Account Type"
             ></v-select>
              <v-text-field
                v-model="newUser.email"
                label="E-mail"
                required
                :suffix="newUser.accountType == 'townsendharris.org'? '@townsendharris.org':''"
                :error-messages="newUserEmailErrorMessage"
              />
              <v-btn
              v-show="newUser.accountType == 'townsendharris.org'"
              @click="verifyUserGmailAccount"
              >Verify Account</v-btn>
              <v-text-field
                v-model="newUser.name"
                label="Name"
                required
                :disabled="newUser.accountType == 'townsendharris.org'"
                :messages="newUserNameMessage"
              />
              <v-text-field
                v-show="newUser.accountType == 'other'"
                v-model="newUser.password"
                label="Password"
                required
              />
              <v-checkbox
                v-model="newUser.isAdmin"
                label="Admin"
              />
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions style="padding-right:50px">
          <v-spacer />
          <v-btn
            color="error"
            @click="resetNewUserForm()"
          >
            Reset Form
          </v-btn>
          <v-btn
            color="success"
            :loading="newUserCreating"
            @click="createUser()"
          >
            Create User
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row
      wrap
      align-start
    >
      <v-flex xs9>
        <h2>Teacher / Staff / User Accounts</h2>
        <v-form>
          <v-container>
            <v-layout>
              <v-flex>
                <v-text-field
                  v-model="table.search"
                  clearable
                  label="Search by Name / Email / Role"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-flex>
      <v-flex>
        <v-btn
          @click="toggleNewUserModal"
        >
          New User Access
        </v-btn>
      </v-flex>
    </v-row>
    <v-row>
    <v-col>
      <v-card>
      <v-data-table
        :headers="table.headers"
        :height="700"
        :items="users"
        :loading="table.loading"
        :hide-default-footer="true"
        :sort-by="['email']"
        :disable-pagination="true"
        :search="table.search"
        dense
      >
        <template v-slot:item="props">
          <tr :class="props.item.role === 'DISABLED'? 'grey lighten-2' :''">
            <td style="font-size:13px">{{ props.item.email }}
            </td>
            <td style="font-size:13px">{{ props.item.name }}
            </td>
            <td>
              <v-btn x-small text v-if="!props.item.skedula_email"
                @click="openSkedulaModal(props.item)"
              >
                <span>add link</span>
              </v-btn>
              <v-btn x-small color="green" text v-if="props.item.skedula_email"
                @click="openSkedulaModal(props.item)"
              >
                {{ props.item.skedula_email }}
              </v-btn>
            </td>
            <td style="font-size:13px">
              {{ props.item.skedula_title }}
            </td>
            <td style="font-size:13px">
              {{ props.item.skedula_user_type }}
            </td>
            <td>
              <v-chip
                v-if="props.item.role != 'OPERATOR'"
                :color="props.item.role === 'ADMIN' ? 'green': props.item.role === 'OPERATOR' ? 'orange' : 'grey' "
                outlined
                x-small
              >
                {{ props.item.role }}
              </v-chip>
            </td>
            <td>
              <v-menu v-if="user.isAdmin">
                <template v-slot:activator="{ on }">
                    <v-icon
                      small
                      class="mr-2"
                      v-on="on"
                    >
                      edit
                    </v-icon>
                </template>
                <v-list
                :dense="true"
                >
                <v-list-item>
                  <v-avatar>
                    <v-icon>person</v-icon>
                  </v-avatar>{{ props.item.name }}</v-list-item>
                  <v-divider></v-divider>
                <v-subheader>Update Status</v-subheader>
                  <v-list-item
                    @click="updateRole(props.item, 'ADMIN')"
                  >
                    <v-list-item-title>Admin</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click="updateRole(props.item, 'OPERATOR')"
                  >
                    <v-list-item-title>Operator</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click="updateRole(props.item, 'DISABLED')"
                  >
                    <v-list-item-title>Disabled</v-list-item-title>
                  </v-list-item>
                  <v-subheader>Skedula</v-subheader>
                  <v-list-item
                      @click="openSkedulaModal(props.item)"
                    >
                      <v-list-item-title>Link Account</v-list-item-title>
                  </v-list-item>

                  <v-subheader v-if="props.item.email.indexOf('@townsendharris.org') === -1">Password</v-subheader>
                  <v-list-item v-if="props.item.email.indexOf('@townsendharris.org') === -1"
                      @click="resetUserPassword(props.item)"
                    >
                      <v-list-item-title>Reset Password</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </v-col>
  </v-row>
  <v-dialog
    v-model="skedula.modal"
    max-width="350px"
  >
    <v-card v-if="skedula.selectedAccount"
      max-height="500px"
      :loading="skedula.loadingTeachers"
    >
    <v-list-item>
         <v-list-item-avatar color="grey"></v-list-item-avatar>
         <v-list-item-content>
           <v-list-item-title class="headline">{{ skedula.selectedAccount.name }}</v-list-item-title>
         </v-list-item-content>
       </v-list-item>

       <v-subheader>Select Skedula User</v-subheader>
       <v-list dense style="padding-top:0px;padding:10px;max-height:200px;overflow-y:auto;overflow-x:hidden">
         <v-list-item
          v-for="u in skedula.users"
          v-show="skedula.showAllUsers || skedula.selectedAccount.email.substring(0,3) == u.email.substring(0,3)"
          :key="u.email"
         >
           <v-list-item-icon>
             <v-icon v-if="skedula.selectedAccount.skedula_email === u.email" color="green">how_to_reg</v-icon>
              <v-icon v-if="skedula.selectedAccount.skedula_email != u.email">person</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title>{{ u.email }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn :loading="skedula.selectedUserEmail == u.email"
                x-small
                v-show="skedula.selectedAccount.skedula_email == u.email"
                @click="unlinkSkedula(u)"
              >
                unlink
              </v-btn>

              <v-btn :loading="skedula.selectedUserEmail == u.email"
                x-small
                v-show="skedula.selectedAccount.skedula_email != u.email"
                @click="linkSkedula(u)"
                >
                link
              </v-btn>
            </v-list-item-action>
         </v-list-item>
       </v-list>
      <v-card-actions style="padding:20px">
        <v-spacer />
        <v-btn small @click="skedula.showAllUsers = true">show all skedula users </v-btn>
        <v-btn
          small
          color="error"
          @click="closeSkedulaModal"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</v-container>
</template>

<script>
const api = require('../apiFunctions.js')
const fb = require('../firebaseConfig.js')

export default {
  data: () => ({
    user: fb.session.user,
    users: [],
    alerts: [],
    skedula: {
      users: [],
      showAllUsers: false,
      modal: false,
      email: '',
      selectedAccount: null,
      selectedUserEmail: '',
      loadingTeachers: true
    },
    newUserModal: false,
    newUserCreating: false,
    newUserEmailErrorMessage: '',
    newUserNameMessage: '',
    newUser: {
      accountType: 'townsendharris.org',
      name: '',
      email: '',
      password: '',
      isAdmin: false
    },
    active: null,
    table: {
      search: '',
      loading: false,
      headers: [
        { text: 'Email', value: 'email' },
        { text: 'Name', value: 'name' },
        { text: 'Skedula User', value: 'skedula_email' },
        { text: 'Sk Title', value: 'skedula_title' },
        { text: 'Sk Role', value: 'skedula_user_type' },
        { text: 'Status', value: 'role' },
        { text: '', value: '' }

      ],
      pagination: {
        rowsPerPage: 25
      }
    },
    editedItem: {},
    selectedItem: null,
    formTitle: 'Edit',
    editModal: false,
    saving: false
  }),
  watch: {
    'newUser.email': function (val) {
      var self = this
      self.newUserEmailErrorMessage = ''
      self.users.forEach((item, i) => {
        if (val === item.email || val === item.email.split('@')[0]) {
          self.newUserEmailErrorMessage = 'email already exists'
        }
      })
    }
  },
  mounted () {
    var self = this
    self.$emit('loading', true, 'retrieving teachers')
    api.users.get((data) => {
      console.log(data)
      self.users = data
      self.$emit('loading', false)
    })
  },
  methods: {
    resetNewUserForm () {
      this.newUser.name = ''
      this.newUser.email = ''
      this.newUser.password = ''
      this.newUser.isAdmin = false
    },
    updateRole (user, role) {
      var self = this
      user.role = role
      api.user.update(user, (resp) => {
        user.role = resp.data.role
        self.$emit('on-notification', user.name + ' updated')
      })
    },
    toggleNewUserModal () {
      this.newUserEmailErrorMessage = ''
      this.newUserNameMessage = ''
      this.newUserModal = !this.newUserModal
    },
    verifyUserGmailAccount: function () {
      var self = this
      api.students.gmailInfo(this.newUser.email, (data) => {
        if (data.body.valid) {
          self.newUser.name = self.newUser.email
          self.newUserNameMessage = data.body.display_name
        } else {
          self.newUserEmailErrorMessage = 'Invalid Email Address'
        }
      })
    },
    createUser () {
      var self = this
      if (self.newUserEmailErrorMessage.length > 0) {
        alert('please fix email errors first')
        return
      }
      this.newUserCreating = true
      api.user.create(this.newUser, (resp) => {
        console.log(resp.data)
        self.users.unshift(resp.data)
        this.newUserCreating = false
        self.resetNewUserForm()
        self.$emit('on-notification', resp.data.name + ' created')
      })
    },
    resetUserPassword (user) {
      if (confirm('Reset user ' + user.name + ' password ?')) {
        fb.auth.sendPasswordResetEmail(user.email).then(function () {
          alert('An email was sent to ' + user.email + ' to reset  password')
        })
      }
    },
    openSkedulaModal (item) {
      var self = this
      console.log(item)
      self.skedula.modal = true
      self.skedula.selectedAccount = item
      self.skedula.showAllUsers = false
      if (self.skedula.users.length === 0) {
        self.skedula.loadingTeachers = true
        api.get('getSkedulaTeachers', {}, (data) => {
          console.log(data)
          self.skedula.users = data
          self.skedula.loadingTeachers = false
        })
      }
    },
    linkSkedula: function (account) {
      var self = this
      console.log('linking', account )
      self.skedula.selectedUserEmail = account.email
      api.post('setSkedulaEmail', { teacher_uid: this.skedula.selectedAccount.email,
                                              email: this.skedula.selectedUserEmail }, (data) => {
        console.log(data)
        self.skedula.selectedAccount.skedula_email = self.skedula.selectedUserEmail
        self.closeSkedulaModal()
      })
    },
    unlinkSkedula: function (account) {
      console.log('unlinking', account)
      var self = this
      api.get('setSkedulaEmail', { teacher_uid: this.skedula.selectedAccount.email,
                                              email: null}, (data) => {
        self.skedula.selectedAccount.skedula_email = null
      })
    },
    closeSkedulaModal () {
      this.skedula.selectedUserEmail = ''
      this.skedula.selectedAccount  = null
      this.skedula.modal = false
    }
  }
}
</script>
